import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IOrgNameEditorProps {
    value: string;
    onUpdate: (field: 'name', value: string) => void;
}

export default function OrgNameEditor({ value = '', onUpdate }: IOrgNameEditorProps) {
    const { t } = useTranslation();
    return (
        <TextField
            fullWidth
            label={t('common:organization.orgName')}
            value={value}
            placeholder={'-'}
            onChange={(e) => onUpdate('name', e.target.value)}
        />
    );
}
